module.exports = __webpack_public_path__ + "img/easytick_color.648e701e.png";